import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import Info from "./Info";

const Hero = () => {
  const isDesktopLarge = useMediaQuery("(min-width:1920px)");
  const isDesktop = useMediaQuery("(min-width:1280px)");
  const isTabletLand = useMediaQuery(
    "(min-width:900px) and (orientation: landscape)",
  );
  const isTabletPort = useMediaQuery(
    "(min-width:600px) and (orientation: portrait)",
  );

  let videoSrc = "/hero/videos/mobile.mp4";
  if (isDesktopLarge) videoSrc = "/hero/videos/big.mp4";
  else if (isDesktop) videoSrc = "/hero/videos/big.mp4";
  else if (isTabletLand) videoSrc = "/hero/videos/tablet-landscape.mp4";
  else if (isTabletPort) videoSrc = "/hero/videos/tablet-portrait.mp4";

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: { xs: "flex-start", sm: "flex-start", md: "flex-start" },
        justifyContent: "center",
        textAlign: { xs: "left", md: "left" },
        minHeight: { xs: "85vh", md: "100vh" },
        backgroundImage: "none",
        color: "#fff",
        px: { xs: 3, md: 12 },
      }}
    >
      <Box
        component="video"
        src={videoSrc}
        autoPlay
        loop
        muted
        playsInline
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
        }}
      />

      <Typography
        variant="h1"
        sx={{
          fontWeight: "bold",
          mb: { xs: 1, md: 2 },
          fontSize: { xs: "1.5rem", md: "4.5rem" },
          lineHeight: { xs: 1.3, md: 1.1 },
          maxWidth: "800px",
          textAlign: { xs: "left", md: "left" }, // ← 追加
        }}
      >
        言葉にできない
      </Typography>

      <Typography
        variant="h1"
        sx={{
          fontWeight: "bold",
          mb: { xs: 4, md: 6 },
          fontSize: { xs: "1.5rem", md: "4.5rem" },
          lineHeight: { xs: 1.3, md: 1.1 },
          maxWidth: "800px",
          textAlign: { xs: "left", md: "left" }, // ← 追加
        }}
      >
        『らしさ』をカタチに。
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "0.75rem", md: "1.25rem" },
          lineHeight: 1.8,
          maxWidth: "730px",
        }}
      >
        多彩なクリエイティブでプロダクトの輪郭を見える化し、課題解決に伴走します
      </Typography>

      <Info />
    </Box>
  );
};

export default Hero;
